import { useRouter } from 'next/router'
import YouTube from 'react-youtube'
import NoSSR from '../../../components/common/NoSSR'
import { useCountdownTimer } from '../../../modules/hooks/common/useCountdownTimer'

interface YoutubePlayerProps {
  item: {
    code: string
  }
  onEnd: (i: number) => void
  checkYoutube?: () => void
  onPlay?: (i: number, playbackTime: number) => void
  onPause?: (i: number) => void
  key: number
  clx?: string
}

const YoutubePlayer = ({ item, onEnd, checkYoutube, onPlay, onPause, key, clx }: YoutubePlayerProps) => {
  const { countdown, start, reset, pause, isRunning } = useCountdownTimer({
    timer: 1000 * 10,
    onExpire: () => {
      if (checkYoutube) {
        checkYoutube()
      }
    },
  })
  const handlePlay = (i, playbackTime) => {
    onPlay && onPlay(i, playbackTime)
    start()
  }
  const handlePause = (i) => {
    onPause && onPause(i)
    pause()
  }
  const router = useRouter()

  let playbackQuery = 0
  // 이 케이스 빼고는 모두 0을 유지
  if (Array.isArray(router?.query?.video_playback)) {
    if (router?.query?.video_playback.length > 0) {
      playbackQuery = parseInt(router?.query?.video_playback[0], 10)
    }
  } else if (router?.query?.video_playback) {
    playbackQuery = parseInt(router?.query?.video_playback, 10)
  }
  const youtubeWidth = clx ? `${clx}` : 'mb-3 w-full'

  return (
    <div className="mb-[16px] w-full">
      <NoSSR key={item?.code}>
        <div className="mx-auto w-full">
          {item?.code && (
            <YouTube
              onPlay={(e) => handlePlay(key, e.target.getCurrentTime())}
              className={youtubeWidth}
              videoId={item?.code}
              onEnd={() => onEnd(key)}
              onPause={() => handlePause(key)}
              iframeClassName="w-full"
              opts={{
                playerVars: {
                  enablejsapi: 1,
                  origin: 'http://localhost:3000',
                  start: playbackQuery,
                },
              }}
            />
          )}
        </div>
      </NoSSR>
    </div>
  )
}

export default YoutubePlayer
